// extracted by mini-css-extract-plugin
export default {"metadata":"metadata-TR01x","no-border-top":"no-border-top-Wz1bI"};